module.exports = __webpack_public_path__ + "static/img/COC2021-16.7693998.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-16.jpg
// module id = skFs
// module chunks = 0